export const GOOGLE_WALLET_FAILED = "We couldn’t add this to Google Wallet. Please use the ticket or pass shown on this page.";
export const GOOGLE_WALLET_POPUP_BLOCKED = "We couldn’t open Google Wallet. Allow pop-ups for this site and try again.";
